export default __webpack_public_path__ + "static/media/README.0b28e8d9.md";